import React, { useMemo } from 'react';
import { createSelectorHook, shallowEqual } from 'react-redux';
import { bindActionCreators } from 'redux'; // eslint-disable-next-line @reskript/no-excessive-hook

export var useFrameworkDispatch = function useFrameworkDispatch() {
  var _window$__icloud__$st;

  var dispatch = (_window$__icloud__$st = window.__icloud__.store) === null || _window$__icloud__$st === void 0 ? void 0 : _window$__icloud__$st.dispatch;

  if (!dispatch) {
    throw new Error('useFrameworkDispatch: dispatch is not defined');
  }

  return dispatch;
};
export var getFrameworkState = function getFrameworkState() {
  var _window$__icloud__$st2;

  return (_window$__icloud__$st2 = window.__icloud__.store) === null || _window$__icloud__$st2 === void 0 ? void 0 : _window$__icloud__$st2.getState();
};
export var genUseSelector = function genUseSelector() {
  var store = window.__icloud__.store;
  return createSelectorHook( /*#__PURE__*/React.createContext({
    store: store,
    storeState: store.getState()
  }));
};
export var useSliceAction = function useSliceAction(actions) {
  var dispatch = useFrameworkDispatch();
  return useMemo(function () {
    return bindActionCreators(actions, dispatch);
  }, [actions, dispatch]);
};
/**
 * 生成对应slice的state，api类似于useSelector，但是equalityFn用了shallowEqual
 */

export var genSliceStateSelector = function genSliceStateSelector(slice) {
  var defaultSelector = function defaultSelector(s) {
    return s;
  };

  return function () {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSelector;
    var equalityFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : shallowEqual;
    var hookRef = React.useRef(genUseSelector());
    var useSelector = hookRef.current;
    return useSelector(function (s) {
      // @ts-ignore
      return selector(s[slice.name]);
    }, equalityFn);
  };
};
export var genSliceInit = function genSliceInit(slice) {
  return function (store) {
    var asyncReducers = store.asyncReducers;

    if (asyncReducers[slice.name]) {
      return;
    }

    store.injectReducer(slice.name, slice.reducer);
  };
};
export var genGetSliceState = function genGetSliceState(slice) {
  // @ts-ignore
  return function () {
    return getFrameworkState()[slice.name];
  };
};
//# sourceMappingURL=es/utils.js.map